import { asCurrency, getMonthlyPayment, updateValuesFromFields, validateFields } from '../util'
import { useState, useEffect } from 'react'

const getInitialFields = () => {
  return [
    {
      name: 'numPayments',
      dataType: 'int',
      value: '',
    },
    {
      name: 'interestRate',
      dataType: 'float',
      value: '',
    },
    {
      name: 'principal',
      dataType: 'float',
      value: '',
    },
  ]
}

function ScratchpadRow() {
  const [fields, setFields] = useState(getInitialFields())
  const [monthlyPayment, setMonthlyPayment] = useState('')
  const [canSubmit, setCanSubmit] = useState(false)

  useEffect(() => {
    const hasNoEmptyFields = fields.filter((x) => x.value === '').length === 0
    setCanSubmit(hasNoEmptyFields)
  }, [fields, setCanSubmit])

  const handleChange = (e) => {
    const newFields = [...fields]
    const field = newFields.find((x) => x.name === e.target.name)
    field.value = e.target.value
    setFields(newFields)
    setMonthlyPayment('')
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const validate = validateFields(fields)

    if (validate.isValid) {
      const values = updateValuesFromFields({}, fields)
      const monthlyPayment = getMonthlyPayment(values.principal, values.interestRate, values.numPayments)

      setMonthlyPayment(asCurrency(monthlyPayment))
    }
  }

  const handleReset = (e) => {
    e.preventDefault()
    setFields(getInitialFields())
    setMonthlyPayment('')
  }

  return (
    <form
      className="grid grid-cols-5 divide-x divide-gray-300 md:grid-cols-6"
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      {fields.map((field) => (
        <div key={field.name} className="flex py-3 px-2">
          <input
            type="number"
            inputMode="decimal"
            name={field.name}
            className="py-1 px-2 m-auto w-full text-base rounded-md border border-gray-300"
            value={field.value}
            onChange={handleChange}
          />
        </div>
      ))}

      <div className="flex py-3 px-2">
        <span className="m-auto font-bold">{monthlyPayment}</span>
      </div>

      <div className="flex flex-col justify-center items-center py-3 px-2 md:flex-row md:col-span-2 md:space-x-4 md:text-sm text-xxs sm-down:space-y-2">
        <button
          type="submit"
          disabled={!canSubmit}
          className={`py-1 px-2 text-white rounded-md bg-green ${canSubmit ? '' : 'opacity-50'}`}
        >
          Compute
        </button>
        <button type="reset" className="py-1 px-3 rounded-md border">
          Reset
        </button>
      </div>
    </form>
  )
}

function PanelCalculate() {
  return (
    <div className="border-b border-gray-300 divide-y divide-gray-300">
      <div className="grid grid-cols-5 text-center divide-x divide-gray-300 md:grid-cols-6 md:text-sm text-xxs">
        <div className="flex justify-center items-center p-2">Number of Payments</div>
        <div className="flex justify-center items-center p-2">Interest Rate</div>
        <div className="flex justify-center items-center p-2">Principal</div>
        <div className="flex justify-center items-center p-2">Monthly Payment</div>
        <div className="flex justify-center items-center p-2 font-bold md:col-span-2">
          Press to Compute Specific Row
        </div>
      </div>
      <ScratchpadRow />
      <ScratchpadRow />
      <ScratchpadRow />
    </div>
  )
}

export default {
  name: 'Fixed Loan Scratchpad',
  tabs: [
    {
      name: 'Calculate',
      component: PanelCalculate,
    },
  ],
}
